import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { registerMicroApps, start } from "qiankun";

import render from './render/ReactRender';

render({ loading: true });

const loader = loading => render({ loading });

registerMicroApps([
  {
    name: "postLoan", // app name registered
    entry: "//39.104.136.10:3014",
    container: "#souche",
    activeRule: "/postLoan",
    loader,
    props: {
      login: {
        userName: 'ADMIN',
        password: '12345678q',
      }
    },
  },
  {
    name: "edi", // app name registered
    entry: "//39.104.136.10:3013/edi",
    container: "#orderEdi",
    activeRule: "/edi",
    loader,
    props: {
      login: {
        username: 'lianpf',
        remember: true,
        password: '12345678q',
      }
    },
  },
  {
    name: "muyuan", // app name registered
    entry: "//39.104.136.10:3015/muyuan",
    container: "#muyuanDom",
    activeRule: "/muyuan",
    loader,
    props: {
      login: {
        mobile: "18336671829",
        password: "18336671829",
        captcha: "123",
      }
    },
  },
  {
    name: "clearing", // app name registered
    entry: "//39.104.136.10:3016",
    container: "#clearDom",
    activeRule: "/clearing",
    loader,
    props: {
      login: {
        username: 'admin',
        password: '12345678',
      }
    },
  },
  {
    name: "blockChain", // app name registered
    entry: "//39.104.136.10:3017",
    container: "#blockDom",
    activeRule: "/blockChain",
    loader,
    props: {
      login: {
        username: 'admin',
        password: '12345678',
      }
    },
  },
  {
    name: "kssl", // app name registered
    entry: "//39.104.136.10:8009",
    container: "#ksslDom",
    activeRule: "/kssl",
    loader,
    props: {
      login: {
        username: 'admin',
        password: '12345678',
      }
    },
  },
  {
    name: "ljf", // app name registered
    entry: "//39.104.136.10:3012",
    container: "#ljfDom",
    activeRule: "/ljf",
    loader,
    props: {
      login: {
        mobile: '18301389086',
        password: '123456',
      }
    },
  },
],
{
  beforeLoad: [
    app => {
      console.log('[LifeCycle] before load %c%s', 'color: green;', app.name);
    },
  ] as any,
  beforeMount: [
    app => {
      console.log('[LifeCycle] before mount %c%s', 'color: green;', app.name);
    },
  ] as any,
  afterUnmount: [
    app => {
      console.log('[LifeCycle] after unmount %c%s', 'color: green;', app.name);
    },
  ] as any,
});

start({
  prefetch: false, // 取消预加载
  sandbox: true,
});

// console.log('roots', document.getElementById("root"))

// ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
